module.exports = __webpack_public_path__ + "static/img/reference_pic.0be5c7ff.png";